import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ExternalLinkIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
const RELEASES = [{
  title: 'Fighting the Pitcher',
  type: 'Album',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/3ijMaAxhSAShvoBNDc2hfR/3.png',
  url: 'https://ruslansilvr.ffm.to/ftp'
}, {
  title: 'Daydream',
  type: 'Single',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/jU3ruGHHTmwwmTWV8GxKmk/newer_one.png',
  url: 'https://ruslansilvr.ffm.to/daydream'
}, {
  title: 'juk',
  type: 'Single',
  year: '2023',
  image: 'https://cdn.magicpatterns.com/uploads/5eNvLoXK6UW66JNDiZSYPq/Untitled_design-14.png',
  url: 'https://ruslansilvr.ffm.to/juk'
}];
const PLATFORMS = [{
  name: 'SoundCloud',
  url: 'https://ruslansilvr.ffm.to/bio'
}];
export function Music() {
  return <section id="music" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-51">
      <SectionHeader number="02" title="Music" data-id="element-52" />

      {/* Releases Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24" data-id="element-53">
        {RELEASES.map((release, i) => <motion.a key={release.title} href={release.url} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.15,
        duration: 0.6
      }} className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-4 focus-visible:ring-offset-brand-black" data-id="element-54">
            <div className="relative aspect-square overflow-hidden bg-brand-surface mb-4" data-id="element-55">
              {release.image && <img src={release.image} alt={release.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-56" />}
            </div>
            <div className="flex justify-between items-start" data-id="element-57">
              <div data-id="element-58">
                <h4 className="font-display text-2xl text-brand-white uppercase tracking-wider mb-1" data-id="element-59">
                  {release.title}
                </h4>
                <p className="text-brand-muted text-sm uppercase tracking-widest" data-id="element-60">
                  {release.type}
                </p>
              </div>
            </div>
          </motion.a>)}
      </div>

      {/* Streaming Platforms */}
      
    </section>;
}